export default {
  location: '公司所在地',
  country: '国家',
  state: '省份',
  city: '城市',
  detailAddress: '详细地址填写',
  registerSuccess: '注册成功',
  registerError: '账号名已存在或手机号已注册',
  // 企业商户
  companyName: '企业名称',
  companyNamePlaceholder: '填写营业执照上的公司名称',
  companyRegistrationNo: '公司注册编号',
  companyNoPlaceholder: '填写营业执照上的编号(社会信用码)',
  registerCode: '营业执照编号/纳税编号',
  taxIdentificationNumber: '纳税人识别号',
  taxIdentificationPlaceholder: '填写纳税人识别号（社会信用编码）',
  companyUpload: '上传营业执照照片',
  companyUploadTin: '上传TIN证明及营业执照照片',
  ruleMsgCompanyName: '请检查企业名称',
  ruleMsgRegisterCode: '请检查注册号',
  ruleMsgCompanyImage: '请上传照片',
  ruleMsgCompanyTooMore: '照片不能超过3张',
  companyRegistrationUpload: '公司营业执照',
  taxIdentificationNumberUpload: '纳税识别号',
  taxIdentificationNumberUploadTin: 'TIN证明',
  supportImag: '支持文件格式 jpg, jpeg, png, pdf',
  // 个人商户
  nameCr: '姓名',
  name: '姓名',
  IDCr: 'ID 类型',
  ID: '身份证号',
  nationalID: '身份证',
  passport: '护照',
  idNumber: ' ID 类型',
  idNumberPlaceholder: '填写合法证件编号',
  email: '邮箱',
  emailCr: '邮箱',
  emailCrPlaceholder: '请填写法人联系邮箱，以接收该资质相关的通知。',
  contactAddress: '联系地址',
  businessAddress: '经营场所地址',
  personalUpload: '上传身份证正反面',
  ruleMsgName: '请检查姓名',
  ruleMsgID: '请检查身份证号',
  ruleMsgImage: '请上传身份证正反面',
  ruleMsgOne: '请上传正反面2张照片',
  ruleMsgTooMore: '身份证照片不能超过2张',
  ruleMsgState: '请选择省份',
  ruleMsgCity: '请选择城市',
  ruleMsgAddress: '请输入详细地址',
  frontSide: '正面',
  backSide: '反面',

  // 法人信息、结算信息
  basicInfoTitle: '基本信息',
  corportateInfoTitle: '企业法人信息',
  settlementInfoTitle: '结算信息',
  phoneNo: '联系电话',
  idPhoneFront: '身份证正面照',
  idPhoneBack: '身份证反面照',
  frontOfPassport: '护照正面',
  settlementMethod: '结算方式',
  settlementCycle: '结算周期',
  settlementCurrency: '结算货币',
  expectedSettlementCurrency: '预期的结算货币',
  bankName: '银行名称',
  bankNamePlaceholder: '请输入银行全名',
  bankBranchName: '银行分行名称',
  bankBranchNamePlaceholder: '请输入银行分行名称',
  sWIFTCode: 'SWIFT编码',
  bankCode: '银行编码 + 支行编码',
  bankLocation: '银行地址',
  accountName: '银行账户名称',
  cr12: 'CR12',
  cf20: 'CF20',
  accountNamePlaceholder: '请填写公司或法人的银行账户名',
  accountNameYourPlaceholder: '请填写自己名下的银行账户名',
  accountNo: '银行账号',
  accountNoPlaceholder: '请仅输入帐号 (0-9)',
  bankCard: '银行卡',
  monthlySettlement: '月结',
  weeklySettlement: '周结',
  ruleInput: '请输入',
  ruleSelect: '请选择',
  ruleUpload: '请上传',
  messageInfoA: '请确保所填写的账户正确且可正常使用，账户信息的任何更改都需要进行审核',
  messageInfoB: '请确保结算信息填写无误，且结算主体与上面商业基本信息主体保持一致',
  protocolContent: '我承诺以上所填信息真实有效，否则我愿意承担一切法律责任和风险损失',
  // merchantRegistration: '我已仔细阅读并同意《Kilimall 平台卖家服务协议》和 《LipaPay 合作协议》',
  merchantRegistration: '我已仔细阅读并同意',
  KilimallEContract: '《Kilimall 平台卖家服务协议》',
  and: '和',
  LipaPayConditions: '《LipaPay 合作协议》',
  MPESRegisteredName: 'M-PESA注册帐户名',
  MPESRegisteredPhone: 'M-PESA注册电话号码',
  bankInfoDocument: '银行信息证明文件',
  officialBankAccount: '上传可以证明账户所有权的官方的银行文件',
  acceptableDocuments: '支持的文件有：银行账号注册文件，银行身份证明文件、银行账户流水文件或银行卡。',
  diffIdTip: '您填写的编号已经被其他卖家使用，请重新填写',
  confirmDeletedPhone: '是否要删除此照片？',
  resubmitForReview: '重新提交审核',
  save: '保存',
  mainQualification: '常用商户资质信息',
  successfully: '提交成功',
  storeInformation: '店铺信息',
  view: '查看',
  edit: '编辑',
  storeInformationEditting: '店铺信息编辑',
  applicationID: '申请编号',
  approvalStatus: '审核状态',
  rejectionReason: '拒绝原因',
  idNumSupportLettersAndDigits: '您的证件编号只允许填写字母或数字。',
  nameTitle: '名称',
  multipleStoresCannotCorrected: '原资质有多个店铺，不能进行单一订正',
  manage: '管理',
  lengthNotMeet: '您的身份证编码长度不符合要求。',
  pleaseBankCodeAndBranchCode: '请填写银行编码和支行编码，例如银行编码为 30，支行编码为555，则填写 30555'
}
